// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar[data-v-79842734]{height:85%;position:relative;display:flex;flex-direction:column;justify-content:space-between}", ""]);
// Exports
module.exports = exports;
